"use strict";

var objToString = Object.prototype.toString, id = objToString.call("");

module.exports = function (value) {
	return (
		typeof value === "string" ||
		(value &&
			typeof value === "object" &&
			(value instanceof String || objToString.call(value) === id)) ||
		false
	);
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/string/is-string.js
// module id = 426
// module chunks = 54